import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import Toggle from '../toggle';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
const defaultRules = {};

const ToggleField = ({ name, control, rules = defaultRules, onChange = noop, ...otherProps }) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (event) => {
      field.onChange(event);
      if (onChange) onChange(event);
    },
    [field, onChange]
  );

  return (
    <div className="ws-ui-toggle-field">
      <Toggle
        {...otherProps}
        name={field.name}
        value={field.name}
        checked={!!field.value}
        onChange={handleChange}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </div>
  );
};

export default ToggleField;
